const fontFamily = "Plus Jakarta Sans";
const ink = "#15202A";
const muted = "#4F657B";

export const page = {
  width: "100%",
  minHeight: "100%",
  padding: "24px",
  boxSizing: "border-box",
  fontFamily,
  color: ink,
  "@media (max-width: 700px)": {
    padding: "16px",
  },
};

export const pageHeader = {
  marginBottom: "20px",
};

export const title = {
  fontFamily,
  fontWeight: 600,
  fontSize: "22px",
  lineHeight: 1.3,
  marginBottom: "6px",
};

export const subtitle = {
  fontFamily,
  color: muted,
  fontSize: "13px",
};

export const disclaimer = {
  display: "flex",
  alignItems: "flex-start",
  gap: "10px",
  border: "1px solid #2970FF",
  backgroundColor: "#F8FAFF",
  borderRadius: "8px",
  padding: "12px",
  marginBottom: "24px",
};

export const infoIcon = {
  color: "#155EEF",
  fontSize: "18px",
  marginTop: "1px",
};

export const disclaimerContent = {
  flex: 1,
  minWidth: 0,
};

export const disclaimerTitle = {
  fontFamily,
  fontWeight: 600,
  fontSize: "13px",
  lineHeight: 1.4,
};

export const disclaimerText = {
  fontFamily,
  color: "#344554",
  fontSize: "11px",
  lineHeight: 1.45,
};

export const disclaimerLink = {
  color: "#155EEF",
  fontFamily,
  fontSize: "inherit",
};

export const closeButton = {
  color: ink,
  padding: "2px",
  "& svg": {
    fontSize: "20px",
  },
};

export const toolbar = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "20px",
  border: "1px solid #E2E8F0",
  borderRadius: "12px",
  padding: "10px 16px",
  marginBottom: "24px",
  backgroundColor: "#FFFFFF",
  "@media (max-width: 1050px)": {
    alignItems: "stretch",
    flexDirection: "column",
  },
};

export const tabs = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  overflowX: "auto",
};

export const tab = (active) => ({
  position: "relative",
  minWidth: "max-content",
  padding: "10px 8px",
  color: ink,
  fontFamily,
  fontSize: "12px",
  fontWeight: active ? 600 : 400,
  textTransform: "none",
  borderRadius: 0,
  "&::after": active
    ? {
        content: '""',
        position: "absolute",
        left: "14px",
        right: "14px",
        bottom: 0,
        height: "3px",
        borderRadius: "3px",
        backgroundColor: ink,
      }
    : {},
});

export const search = {
  width: "270px",
  flexShrink: 0,
  "& .MuiOutlinedInput-root": {
    height: "42px",
    borderRadius: "8px",
    fontFamily,
    fontSize: "12px",
  },
  "@media (max-width: 1050px)": {
    width: "100%",
  },
};

export const sections = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};

export const section = {
  backgroundColor: "#ECF1F7",
  borderRadius: "16px",
  padding: "22px 28px",
  "@media (max-width: 700px)": {
    padding: "18px",
  },
};

export const sectionHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "14px",
};

export const sectionTitle = {
  fontFamily,
  fontWeight: 600,
  fontSize: "16px",
};

export const seeAllButton = {
  borderColor: ink,
  color: ink,
  borderRadius: "8px",
  padding: "5px 11px",
  minWidth: 0,
  fontFamily,
  fontSize: "11px",
  fontWeight: 600,
  textTransform: "none",
  "& .material-symbols-outlined": {
    fontSize: "14px",
  },
  "&:hover": {
    borderColor: ink,
    backgroundColor: "rgba(21, 32, 42, 0.04)",
  },
};

export const cardGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: "20px",
  "@media (max-width: 1100px)": {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
  "@media (max-width: 700px)": {
    gridTemplateColumns: "1fr",
  },
};

export const card = {
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  backgroundColor: "#FFFFFF",
  border: "1px solid #E6EBF0",
  borderRadius: "16px",
  padding: "16px",
};

export const preview = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  aspectRatio: "1.9 / 1",
  overflow: "hidden",
  borderRadius: "14px",
  marginBottom: "14px",
  background:
    "radial-gradient(circle at 10% 90%, #04C9A6 0, transparent 38%), radial-gradient(circle at 100% 80%, #C83243 0, transparent 45%), linear-gradient(125deg, #073A91 0%, #06182F 58%, #171122 100%)",
  "& img": {
    width: "62%",
    maxHeight: "52px",
    objectFit: "contain",
    filter: "brightness(0) invert(1)",
  },
};

export const previewButton = {
  position: "absolute",
  top: "7px",
  right: "7px",
  width: "24px",
  height: "24px",
  color: ink,
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  "&:hover": {
    backgroundColor: "#FFFFFF",
  },
};

export const cardTitle = {
  minHeight: "36px",
  fontFamily,
  fontWeight: 600,
  fontSize: "13px",
  lineHeight: 1.4,
  marginBottom: "8px",
  overflowWrap: "anywhere",
};

export const details = {
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  marginBottom: "14px",
};

export const detailRow = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "10px",
  minHeight: "17px",
};

export const detailLabel = {
  color: muted,
  fontFamily,
  fontSize: "10.5px",
};

export const detailValue = {
  color: ink,
  fontFamily,
  fontSize: "10.5px",
  textAlign: "right",
};

export const tags = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  gap: "6px",
};

export const tag = {
  padding: "2px 8px",
  borderRadius: "5px",
  color: "#155EEF",
  backgroundColor: "#D1E0FF",
  fontFamily,
  fontSize: "9.5px",
};

export const cardActions = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  marginTop: "auto",
};

export const selectLater = {
  display: "flex",
  alignItems: "center",
  minWidth: 0,
};

export const checkbox = {
  padding: 0,
  marginRight: "6px",
  color: "#4F657B",
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
  },
};

export const selectText = {
  color: "#526779",
  fontFamily,
  fontSize: "9px",
  whiteSpace: "nowrap",
  "@media (max-width: 1350px)": {
    whiteSpace: "normal",
  },
};

export const downloadButton = {
  flexShrink: 0,
  minWidth: 0,
  padding: "3px 8px",
  borderColor: ink,
  borderRadius: "7px",
  color: ink,
  fontFamily,
  fontSize: "9.5px",
  lineHeight: 1.4,
  textTransform: "none",
  "& .MuiButton-startIcon": {
    marginRight: "3px",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "12px",
  },
  "&:hover": {
    borderColor: ink,
    backgroundColor: "rgba(21, 32, 42, 0.04)",
  },
};

export const emptyState = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  minHeight: "220px",
  borderRadius: "16px",
  color: muted,
  backgroundColor: "#ECF1F7",
  fontFamily,
};
